import qs from 'qs';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { SearchControls } from 'src/components/search-controls';
import { StatusFilter } from 'src/components/status-filter';
import { calculateStatusCounts } from 'src/components/status-filter/calculateStatusCounts';
import history from 'src/config/browser-history';
import { IItem, Status } from 'src/graphql/types';
import { orderDetailsRoute } from './route';

export const OrderDetailsSearchControls = ({
  items,
  soldToId,
  statuses,
}: {
  items: IItem[];
  soldToId: string;
  statuses: Status[];
}) => {
  const location = useLocation();

  const applyStatusFilter = (selectedStatuses: Status[]) => {
    const originalParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    history.push(
      orderDetailsRoute(soldToId, {
        ...originalParams,
        status: selectedStatuses.join(',') || undefined,
      })
    );
  };

  return (
    <SearchControls>
      <StatusFilter
        statuses={statuses}
        statusCounts={calculateStatusCounts(items)}
        applyStatusFilter={applyStatusFilter}
      />
    </SearchControls>
  );
};
